import React, { useEffect, useState, memo } from 'react';
import PropTypes from "prop-types";
import html2pdf from 'html2pdf.js';
import { getArtworkForm } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Oval } from 'react-loader-spinner';
const ViewSaleNFT = memo(({ dialogOpan, downloadValue, nftId, nft, printerName }) => {
    const [isPhysicalArt, setIsPhysicalArt] = useState()
    const [compNftId, setCompNftId] = useState()
    const [compArtId, setCompArtId] = useState()
    const [sellItem, setSellItem] = useState()
    const [Error, setError] = useState()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state?.Login);
     const { artWorkForm, loading } = useSelector((state) => state?.Print);

    useEffect(() => {
        setCompArtId(nft?.nft_id?.image_id?._id)
        setCompNftId(nftId)

    }, [nftId, nft])

    useEffect(() => {
        if (compArtId && compNftId) {
            fetchOrderManagementData()
        }
    }, [compArtId, compNftId])

    useEffect(() => {
        setSellItem(nft)
    }, [nft])

    useEffect(() => {

        if (downloadValue === true) {
            // print()
        }

    }, [downloadValue])
    const closeNFT = () => {
        dialogOpan()
    }

    const fetchOrderManagementData = async () => {
        try {

            const callback = (response) => {
                if (response?.status === "failure") {
                    setError(response?.message);
                } else {
                    setCompArtId(response.data.art_id);
                    setCompNftId(response.data.nft_id);
                }
            }

            if (sellItem?._id && sellItem?.nft_id?.image_id?._id) {
                dispatch(getArtworkForm({ nft_id: sellItem?.nft_id?._id, art_id: sellItem?.nft_id?.image_id?._id }, callback))
            }



        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };

    useEffect(() => {
        if (artWorkForm && Object.keys(artWorkForm).length > 0) {
            setIsPhysicalArt(artWorkForm?.is_physical_art || false);
        }
    }, [artWorkForm]);

    useEffect(() => {
        if (artWorkForm?.art_work) {
            // print();
        }
        console.log('Deepakdata', artWorkForm);
        
    }, [artWorkForm]); // Removed `isPhysicalArt`


    return (
        <div>
            {(loading ) &&
                <div className='loaderBoxMiane'>
                    <Oval
                        height={80}
                        width={80}
                        color="#6C63FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#6C63FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}

                    />
                </div>
            }

            <div className="modal-content text-start" id="modal-content">
                <div id="modal-header" style={{ height: "2.6rem !important" }} >

                    <div className='d-none'>
                        <svg xmlns="http://www.w3.org/2000/svg"  className='download-icon-img' fill="black" viewBox="0 0 512 512"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" /></svg>
                    </div>
                    <svg className="svg-icon-img" onClick={closeNFT} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" /></svg>
                </div>

                <div className="CAOnew" id="printbox" >
                    <div className='innerPrintBox addclassnn'>
                        <div className='print-background'></div>
                        <div className='innerPrintBoxMain'>
                            <div className='text1'>
                                <p>{isPhysicalArt === true ? "LIMITED EDITION PRINT" : "OPEN EDITION PRINT"}</p>
                                <p>{isPhysicalArt === true ? "LIMITED EDITION PRINT" : "OPEN EDITION PRINT"}</p>
                            </div>
                            <div className='printheader'>
                                <p>Certificate of Authenticity</p>
                                <h1> {artWorkForm?.art_work}</h1>
                                <h5>By {user?.name?.charAt(0).toUpperCase() + user?.name?.slice(1) + " " + user?.lastname?.charAt(0).toUpperCase() + user?.lastname?.slice(1)}</h5>

                            </div>
                            {isPhysicalArt === true ?
                                <div className='thisprintbox mt-3'>
                                    <p className='bottomText'>This <span className='textFiled'>{artWorkForm?.art_work}</span> Limited Edition print is one of a limited number of prints that are together referred to in this Certificate of Authenticity as the “Edition.” It is a giclée rendition of a high-resolution digital photographic image of the Artist’s original [oil painting][acrylic painting][watercolor][pencil drawing][ink drawing][mixed media artwork] [etc.],modified to incorporate unique corrections and refinements satisfying the requirements of the Artist. When completed, the image was preserved in only onedigital file,referred to in this Certificate as the “Master.”Duplicates of the Master, identical to it in all respects, have since been made in order to facilitate the creation of the prints in the Edition. Distribution of duplicates is limited to authorized printers contractually bound to use them for no purpose other than the creation of prints in this Edition and to destroy them after such use.References below to the Master include its identical duplicates.</p>
                                    <p>All prints in the Edition are produced from the Master.Prints in the Edition may differ in dimensions or substrate.The Artist has approved the Master and the processes, techniques, materials and proofs used in the production of the Editionin writing.Prints in the Edition are not individually approved by the Artist. The total number of prints that will be produced in the Edition from the Master is shown below.</p>
                                    <div className='fieldBox mb-3'>
                                        {artWorkForm?.is_signed_1 &&
                                            <div className={`checkBoxprint checked `}>  Neither the original artwork nor any prints in the Edition are signed by the Artist.</div>
                                        }
                                        {artWorkForm?.is_signature_from_original_2 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature seen on the print is the signature that appears on the original artwork and is a part of the print itself.</div>
                                        }
                                        {artWorkForm?.is_digital_signature_3 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature on the print is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist and is a part of the print itself.</div>
                                        }
                                        {artWorkForm?.has_two_signatures_4 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature appears twice on the print, in both cases as a part of the print itself. One signature is the signature of the Artist that appears on the original artwork and the other is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist.</div>
                                        }
                                    </div>
                                    <p>This print was created in conjunction with the original sale of aNon-Fungible Token identified by the Token ID shown below (the “Digital Artwork”).The Digital Artwork was minted on the Polygon blockchainby the Artist as part of a limited series of Digital Artworks (“Origin Digital Artworks). The blockchain shows the number of Origin Digital Artworks that are minted as they are minted, and thus the number of prints in the Edition that are created over time.Instead of traditional limited-edition numbering (i.e., 1/40, 2/40, etc.), prints in the Edition have the unique Token ID of theirassociated Non-Fungible Token imprinted in their margin. The Digital Artwork conveys to its owner online-only access to a digital image derived from the Master, and, to the original owner only, it conveyed ownership of a single print in the Edition. This is the print first owned by the original purchaser of the Digital Artwork. It exists wholly apart from and independent of the Digital Artwork. The sale or other transfer of any interest in the Digital Artwork does not transfer any interest in, or have any other effect upon, ownership of thisprint, and vice versa. This print is sold or otherwise transferred off the blockchain.</p>
                                    <p>The following information supplements the information provided above. All information in this Certificate is current as of the date of the signature below.</p>
                                </div> : <div className='thisprintbox mt-3'>
                                    <p className='bottomText'>This <span className='textFiled'>{artWorkForm?.art_work}</span> Open Edition print is one of a number of prints that are together referred to in this Certificate of Authenticity as the “Edition.” It is a giclée rendition of a high-resolution digital photographic image of the Artist’s original [oil painting][acrylic painting][watercolor][pencil drawing][ink drawing][mixed media artwork] [etc.] modified to incorporate unique corrections and refinements satisfying the requirements of the Artist. When completed, the image was preserved in only one digital file, referred to in this Certificate as the “Master.” Duplicates of the Master, identical to it in all respects, have since been made in order to facilitate the creation of the prints in the Edition. Distribution of duplicates is limited to authorized printers contractually bound to use them for no purpose other than the creation of prints in this Edition and to destroy them after such use.References below to the Master include its identical duplicates.</p>
                                    <p>AAll prints in the Edition are produced from the Master.Prints in the Edition may differ in dimensions or substrate. The Artist has approved the Master and the processes, techniques, materials and proofs used in the production of the Edition in writing. The Artist has not specifically approved this individual print. The total number of prints that will be produced in the Edition is unknown.</p>
                                    <div className='fieldBox mb-3'>
                                        {artWorkForm?.is_signed_1 &&
                                            <div className={`checkBoxprint checked `}>  Neither the original artwork nor any prints in the Edition are signed by the Artist.</div>
                                        }
                                        {artWorkForm?.is_signature_from_original_2 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature seen on the print is the signature that appears on the original artwork and is a part of the print itself.</div>
                                        }
                                        {artWorkForm?.is_digital_signature_3 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature on the print is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist and is a part of the print itself.</div>
                                        }
                                        {artWorkForm?.has_two_signatures_4 &&
                                            <div className={`checkBoxprint checked `}>Prints in the Edition are not individually signed by the Artist. The Artist’s signature appears twice on the print, in both cases as a part of the print itself. One signature is the signature of the Artist that appears on the original artwork and the other is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist.</div>
                                        }
                                    </div>
                                    <p>The following information supplements the information provided above. All information in this Certificate is current as of the date of the signature below.</p>
                                </div>
                            }
                            <div className="artdetails mt-3">
                                <div className="artbx">{user?.name?.charAt(0).toUpperCase() + user?.name?.slice(1) + " " + user?.lastname?.charAt(0).toUpperCase() + user?.lastname?.slice(1)}</div>
                                <div className="artbx">{artWorkForm?.art_work}</div>
                                <div className="artbx">{sellItem?.nft_id?.name}</div>

                            </div>
                            <div className='thisprintbox mt-4'>
                                <h2>This Print</h2>
                                <div className='printbox'>
                                    {isPhysicalArt === true && <div className='fieldBox'>
                                        <label>Token ID No.</label><span className='tokemId'></span>
                                    </div>}
                                    <div className='fieldBox'>
                                        <label>Year Print Made</label><span>{artWorkForm?.print_made_year}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Printing Process</label><span className='tokemId'>{artWorkForm?.printing_process}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Print Dimensions</label><span>{artWorkForm?.print_dimensions}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Print Substrate</label><span>{artWorkForm?.print_substrate}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Acid-Free</label>
                                        <div className={'checkBoxprint ' + (artWorkForm?.acid_free === "Yes" ? 'checked' : '')}>Yes</div>
                                        <div className={'checkBoxprint ms-3 ' + (artWorkForm?.acid_free === "" ? 'checked' : '')}>No</div>
                                    </div>
                                    {isPhysicalArt === true && (
                                            <div className='fieldBox'>
                                                <label>Restrike/Replacement</label>
                                                <span className='tokemId Replacement'>{artWorkForm?.restrike_replacement}</span>
                                            </div>
                                        )}
                                    <div className='fieldBox'>
                                        <label>Book/Magazine Print</label><span className='textprefiled'></span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Artist living when Print made</label>
                                        <div className={'checkBoxprint ' + (artWorkForm?.artist_living === "Yes" ? 'checked' : '')}>Yes</div>
                                        <div className={'checkBoxprint ms-3 ' + (artWorkForm?.artist_living === "" ? 'checked' : '')}>No</div>

                                    </div>
                                    <div className='fieldBox'>

                                        <label>Print individually signed by the Artist?</label><span className='textprefiled'></span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Print individually approved by the Artist?</label><span className='textprefiled'></span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Printed By</label><span className='tokemId PrintedBy'></span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className='innerPrintBox breakpage addclassnn'>
                        <div className='print-background'></div>

                        <div className='innerPrintBoxMain'>
                            <div className='thisprintbox mt-0'>
                                <h2>Edition Information</h2>
                                <div className='printbox'>
                                    <div className='fieldBox'>
                                        <label>Year Edition Released:</label><span className='textprefiled'>{artWorkForm?.year_edition_released}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Limited Edition:</label><span className='textprefiled'>{artWorkForm?.limited_edition}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Edition Size:</label><span className='textprefiled'>{artWorkForm?.edition_size}</span>
                                    </div>
                                    {isPhysicalArt === true &&
                                        <>
                                            <div className='fieldBox'>
                                                <label>Edition Size (i.e., authorized maximum number of Edition Prints and Edition Proofs combined)</label><span className='textprefiled'>{artWorkForm?.combined_edition_size}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Edition Prints:</label><span className='textprefiled'>{artWorkForm?.edition_print}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Authorized maximum number:</label><span className='textprefiled'>{artWorkForm?.authorized_max_number}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Authorized maximum number numbered but not signed:</label><span className='textprefiled'>{artWorkForm?.authorized_max_number_not_signed}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Authorized maximum number signed and numbered:</label><span className='textprefiled'>{artWorkForm?.authorized_max_number_signed}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Authorized maximum number neither signed nor numbered:</label><span className='textprefiled'>{artWorkForm?.authorized_max_number_nothing}</span>
                                            </div></>
                                    }

                                    {isPhysicalArt === false && <div className='fieldBox'>
                                        <label>Artist living when Edition released:</label><span className='textprefiled'>{artWorkForm?.edition_artist_living}</span>
                                    </div>}
                                </div>
                            </div>
                            {isPhysicalArt === true &&
                                <div className='thisprintbox '>
                                    <h2>Edition Proofs</h2>
                                    <div className='printbox'>
                                        <div className='fieldBox'>
                                            <label>Authorized maximum number:</label><span className='textprefiled'>{artWorkForm?.edition_authorized_max_number}</span>
                                        </div>
                                        <div className='fieldBox'>
                                            <label>Artist's proofs:</label><span className='textprefiled'>{artWorkForm?.edition_artist_proof}</span>
                                        </div>
                                        <div className='fieldBox'>
                                            <label>Printer's proofs:</label><span className='textprefiled'>{artWorkForm?.edition_printer_proof}</span>
                                        </div>
                                        <div className='fieldBox'>
                                            <label>Other proofs:</label><span className='textprefiled'>{artWorkForm?.edition_other_prrof}</span>
                                        </div>

                                        <div className='fieldBox'>
                                            <label>Artist living when Edition released:</label><span className='textprefiled'>{artWorkForm?.edition_artist_living}</span>
                                        </div>

                                    </div>
                                </div>
                            }
                            <div className='thisprintbox'>
                                <h2>Master Information</h2>
                                <div className='printbox'>
                                    <div className='fieldBox'>
                                        <label>Year Master Created:</label><span className='textprefiled'>{artWorkForm?.year_master_created}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Artist living when Print made:</label><span className='textprefiled'>{artWorkForm?.master_artist_living}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Other masters of the Artwork exist?</label><span className='textprefiled'>{artWorkForm?.master_artwork_exist}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Description</label><span className='textprefiled'>{artWorkForm?.description}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Other limited editions produced from the Master:</label><span className='textprefiled'>{artWorkForm?.other_limited_edition}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Edition</label><span className='textprefiled'>{artWorkForm?.master_edition}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Edition Points:</label><span className='textprefiled'>{artWorkForm?.edition_points}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Signed/Numbered:</label><span className='textprefiled'>{artWorkForm?.signed_number}</span>
                                    </div>
                                    {isPhysicalArt === true &&
                                        <>
                                            <div className='fieldBox'>
                                                <label>Editions from the Master other than limited editions:</label><span className='textprefiled'>{artWorkForm?.other_limited_edition}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Edition</label><span className='textprefiled'>{artWorkForm?.master_edition}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Edition Points:</label><span className='textprefiled'>{artWorkForm?.other_master_edition_points}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Proofs:</label><span className='textprefiled'>{artWorkForm?.other_master_proofs}</span>
                                            </div>
                                            <div className='fieldBox'>
                                                <label>Signed/Numbered:</label><span className='textprefiled'>{artWorkForm?.signed_number}</span>
                                            </div>
                                        </>
                                    }
                                    <div className='fieldBox'>
                                        <label>How numbered:</label><span className='textprefiled'>{artWorkForm?.how_numbered}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Total number of prints in other editions, limited or other, produced from the Master:</label><span className='textprefiled'>{artWorkForm?.print_produced}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Total number of prints produced from the Master that are not part of any edition:</label><span className='textprefiled'>{artWorkForm?.print_produced}</span>
                                    </div>
                                    <div className='fieldBox'>
                                        <label>Number of authorized prints of the Artwork not produced from the Master:</label><span className='textprefiled'>{artWorkForm?.non_master_authorized_prints}</span>
                                    </div>
                                    <div className='fieldBox w-100'>
                                        <label>Master destroyed, effaced, altered, defaced or canceled:</label><span className='textprefiled'>{artWorkForm?.destroyed}</span>
                                    </div>
                                    <div className='fieldBox w-100'>
                                        <label>Master Created By:</label><span className='textprefiled'>{artWorkForm?.main_artist}</span>
                                    </div>
                                    <div className='fieldBox w-100'>
                                        <label>Other Artist:</label><span className='textprefiled'>{artWorkForm?.other_artists}</span>
                                    </div>

                                </div>
                            </div>
                            <div className='thisprintbox mt-1'>
                                <p className='bottomText mb-0'>THIS IS TO CERTIFY that all information and statements contained herein are true and correct.</p>             </div>
                            <div className="artdetails mt-2">
                                <div class="artbx artbottom">
                                    {/* <img src={signature} */}
                                    {/* width="150" */}
                                    {/* height="34" /> */}
                                    <p className="signature-text">Signature</p></div>
                                <div class="artbx artbottom"> <p className='text-black'>{new Date(artWorkForm?.created_date).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-')}</p>


                                    {/* {sellitem.created_date} */}
                                    <p className="signature-text">Date</p></div>
                                <div class="artbx artbottom"> <p className='text-black'>{printerName} </p>
                                    <p className="signature-text">Printer Name</p></div>

                            </div>
                            <div className='thisprintbox mt-1'>
                                <p className='bottomText text-center'> Artwork Copyright: @year name of copyright holder</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )


});

ViewSaleNFT.propTypes = {
    toggle: PropTypes.any,
    downloadValue: PropTypes.bool,
    downloadFunc: PropTypes.func,
    isOpen: PropTypes.any,
    nftId: PropTypes.any,
};

export default ViewSaleNFT;







    // const print = () => {
    //     setPdfLoading(true)
    //     const addclassnn = document.querySelectorAll('.addclassnn')
    //     addclassnn.forEach(item => {

    //         item.classList.add('addclassnnc')
    //     })
    //     const element = document.getElementById('printbox');
    //     if (element) {
    //         // Temporarily add print-specific styles
    //         const style = document.createElement('style');
    //         style.type = 'text/css';
    //         style.innerHTML = `
    //             .print-label { margin-top: 2rem !important; }
    //             .createCollection .form-group .form-control{
    //             font-size: 1rem !important}
    //             .modal-body {
    //             padding: 3rem 2rem 3rem 2rem !important;
    //         }`;
    //         document.head.appendChild(style);

    //         // Generate the PDF

    //         html2pdf()
    //             .from(element)
    //             .set({
    //                 filename: 'View-NFT.pdf',
    //                 pagebreak: {
    //                     before: ['.breakpage'], // Ensure this works for your layout
    //                 },
    //                 image: { type: 'png', quality: 0.7 },
    //                 html2canvas: {
    //                     scale: 1.5,
    //                     useCORS: true,
    //                     allowTaint: true,
    //                     backgroundColor: null,
    //                 },
    //                 jsPDF: { orientation: 'portrait', unit: 'mm', format: 'a4', compressPDF: true },
    //             })
    //             .save()
    //             .then(async () => {
    //                 // Cleanup the temporary style

    //                 document.head.removeChild(style);
    //                 setPdfLoading(false)
    //                 downloadFunc(false, nftId)
    //                 addclassnn.forEach(item => {

    //                     item.classList.remove('addclassnnc')
    //                 })
    //                 setIsPhysicalArt()
    //             })
    //             .catch((error) => {
    //                 console.error('Error generating PDF:', error);
    //                 // Cleanup the temporary style
    //                 document.head.removeChild(style);
    //                 setPdfLoading(false)
    //                 addclassnn.forEach(item => {
    //                     item.classList.remove('addclassnnc')
    //                 })
    //             });

    //     } else {
    //         setPdfLoading(false)
    //         console.error('Element not found');
    //     }
    // };
